import { Container, Grid } from '@mui/material';
import React from 'react';
import { ContactForm, Header, OurLocation } from '.';

export default function ContactUs() {
  return (
    <Container id="contactUs" sx={{ pt: { xs: 6, sm: 10 } }}>
      <Grid container spacing={3}>
        <Grid item md={12} lg={5}>
          <Header />
          <OurLocation />
        </Grid>
        <Grid item md={12} lg={7}>
          <ContactForm />
        </Grid>
      </Grid>
    </Container>
  );
}
